export type AccountFlowView =
  | 'accountEntry'
  | 'accountPasswordLogin'
  | 'registerCreatePassword'
  | 'registerBindPhone'
  | 'resetVerifyEmail'
  | 'resetNewPassword'

export type AccountEntryResolution = 'accountPasswordLogin' | 'registerCreatePassword' | 'unsupportedAccount'
export type ThirdPartyRegisterInitialView = 'registerCreatePassword' | 'registerBindPhone' | null

const EMAIL_PATTERN = /^\w+([-.+]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/
const ACCOUNT_PATTERN = /^[A-Za-z0-9][A-Za-z0-9_-]{4,49}$/

export type AccountAuthTranslate = (key: string, values?: Array<string | number>) => string

export const isEmailAccount = (account: string) => account.includes('@')

export const isPlainAccount = (account: string) => ACCOUNT_PATTERN.test(account.trim())

export const validateAccountEntry = (account: string, t: AccountAuthTranslate) => {
  const normalizedAccount = account.trim()
  if (!normalizedAccount) {
    return t('83719')
  }

  if (isEmailAccount(normalizedAccount) && !EMAIL_PATTERN.test(normalizedAccount)) {
    return t('83704')
  }

  if (!isEmailAccount(normalizedAccount) && !ACCOUNT_PATTERN.test(normalizedAccount)) {
    return t('83837')
  }

  return ''
}

export const resolveAccountEntryNextView = ({
  account,
  isRegistered,
}: {
  account: string
  isRegistered: boolean
}): AccountEntryResolution => {
  if (isRegistered) {
    return 'accountPasswordLogin'
  }

  return isEmailAccount(account.trim()) ? 'registerCreatePassword' : 'unsupportedAccount'
}

export const resolveThirdPartyRegisterInitialView = (loginType = '', email = ''): ThirdPartyRegisterInitialView => {
  const normalizedLoginType = loginType.toLowerCase()
  if (
    normalizedLoginType.includes('wechat') ||
    normalizedLoginType.includes('google') ||
    normalizedLoginType.includes('apple') ||
    normalizedLoginType.includes('telegram')
  ) {
    return 'registerBindPhone'
  }

  return email.trim() ? 'registerCreatePassword' : 'registerBindPhone'
}

export const validatePasswordPair = (password: string, confirmPassword: string, t: AccountAuthTranslate) => {
  if (!password || !confirmPassword) {
    return t('82415')
  }

  if (password !== confirmPassword) {
    return t('82930')
  }

  if (!/^\S{6,20}$/.test(password)) {
    return t('82415')
  }

  return ''
}

export const validateSinglePassword = (password: string, t: AccountAuthTranslate) => {
  if (!password.trim()) {
    return t('82415')
  }

  if (!/^\S{6,20}$/.test(password.trim())) {
    return t('82415')
  }

  return ''
}

export const validatePhoneInput = (phone: string, areaCode: string, t: AccountAuthTranslate) => {
  if (areaCode === '0086') {
    if (!/^[1][3-9][0-9]{9}$/.test(phone)) {
      return t('84005')
    }
  } else if (!/^.{5,20}$/.test(phone)) {
    return t('84005')
  }

  return ''
}

export const validateEmailValue = (email: string, t: AccountAuthTranslate) => {
  if (!EMAIL_PATTERN.test(email.trim())) {
    return t('83704')
  }

  return ''
}
